import styled from 'styled-components/macro';

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  position: relative;

  .leaflet-container {
    height: 100% !important;
    width: 100% !important;
  }
`;
